<template>
  <div class="app-container">
    <el-card>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="招聘场次" prop="session_id">
          <el-select v-model="form.session_id" placeholder="请选择招聘场次" style="width:100%" @change="handleSessionChange">
            <el-option v-for="item in sessionOptions" :key="item.id" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="招聘职位" prop="position_id">
          <el-select
            v-model="form.position_id"
            placeholder="请选择招聘职位（多选）"
            style="width:100%"
            filterable
            multiple
            :clearable="true"
          >
            <el-option
              v-for="item in positionOptions"
              :key="item.id"
              :label="item.position_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="选择考场" prop="room_id">
          <el-select
            v-model="form.room_id"
            placeholder="请选择考场（多选）"
            style="width:100%"
            filterable
            multiple
            :clearable="true"
          >
            <el-option
              v-for="item in roomOptions"
              :key="item.id"
              :label="item.room_name + ' (座位：' + item.room_capacity + ')' "
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目名称" prop="exam_name">
          <el-input v-model="form.exam_name" placeholder="请输入考试科目名称" />
        </el-form-item>
        <el-form-item label="考试内容" prop="exam_content">
          <el-input type="textarea" v-model="form.exam_content" placeholder="请输入考试内容" />
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker v-model="form.start_time" type="datetime" placeholder="选择开始时间" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker v-model="form.end_time" type="datetime" placeholder="选择结束时间" style="width:100%" />
        </el-form-item>
        <!-- <el-form-item label="总座位数" prop="total_seats">
          <el-input-number v-model="form.total_seats" :min="1" style="width:100%" />
        </el-form-item> -->
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="form.description" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="saveLoading">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { getAllSessionList } from '@/api/recruitment-session'
import { getAllPositionList } from '@/api/recruitment-position'
import { addExam, editExam, getExamDetail, getAllRoomList } from '@/api/exam'
import request from '@/utils/request'
export default {
  name: 'ExamEdit',
  data() {
    return {
      form: {
        session_id: '',
        position_id: [],
        room_id: [],
        exam_name: '',
        exam_content: '',
        start_time: '',
        end_time: '',
        total_seats: 1,
        description: ''
      },
      rules: {
        session_id: [ { required: true, message: '请选择招聘场次', trigger: 'change' } ],
        // position_id: [ { required: true, message: '请选择招聘职位', trigger: 'change' } ],
        room_id: [ { required: true, message: '请选择考场', trigger: 'change' } ],
        exam_name: [ { required: true, message: '请输入考试科目名称', trigger: 'blur' } ],
        start_time: [ { required: true, message: '请选择开始时间', trigger: 'change' } ],
        end_time: [ { required: true, message: '请选择结束时间', trigger: 'change' } ],
        total_seats: [ { required: true, message: '请输入总座位数', trigger: 'blur' } ]
      },
      isEdit: false,
      sessionOptions: [],
      positionOptions: [],
      roomOptions: [],
      saveLoading: false
    }
  },
  created() {
    this.getSessionOptions()
    this.getRoomOptions()
    if (this.$route.params.id) {
      this.isEdit = true
      this.getDetail()
    }
  },
  methods: {
    async getSessionOptions() {
      // 假设接口 /recruitment-session/list
      getAllSessionList().then(res => {
        this.sessionOptions = res.data.list
      })
    },
    async getRoomOptions() {
      getAllRoomList().then(res => {
        this.roomOptions = res.data.list
      })
    },
    async getPositionOptions(session_id) {
      console.log(session_id)
      if (!session_id) {
        this.positionOptions = []
        return
      }
      getAllPositionList({ session_id: session_id }).then(res => {
        this.positionOptions = res.data.list
      })
    },
    async handleSessionChange(val) {
      this.form.position_id = []
      await this.getPositionOptions(val)
    },
    async getDetail() {
      const res = await getExamDetail(this.$route.params.id)
      this.form = res.data.info
      // 处理多选字段的回显
      if (this.form.position_id) {
        this.form.position_id = typeof this.form.position_id === 'string' 
          ? this.form.position_id.split(',').map(Number)
          : Array.isArray(this.form.position_id) 
            ? this.form.position_id 
            : []
      }
      if (this.form.room_id) {
        this.form.room_id = typeof this.form.room_id === 'string'
          ? this.form.room_id.split(',').map(Number)
          : Array.isArray(this.form.room_id)
            ? this.form.room_id
            : []
      }
      // 回显场次和职位
      await this.getPositionOptions(this.form.session_id)
    },
    handleSubmit() {
      if (this.saveLoading) return
      this.saveLoading = true
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.saveLoading = false
          return
        }
        // 处理多选为后端需要的格式
        const submitForm = { ...this.form }
        if (Array.isArray(submitForm.position_id)) {
          submitForm.position_id = submitForm.position_id.join(',')
        }
        if (Array.isArray(submitForm.room_id)) {
          submitForm.room_id = submitForm.room_id.join(',')
        }
        if (this.isEdit) {
          await editExam(this.$route.params.id, submitForm).then(res => {
            if (res.status === 'success') { 
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.message)
            }
            this.$router.push('/exam')
          }).catch(() => {
            this.saveLoading = false
          })
        } else {
          await addExam(submitForm).then(res => {
            if (res.status === 'success') { 
              this.$message.success('新增成功')
            } else {
              this.$message.error(res.message)
            }
            this.saveLoading = false
            this.$router.push('/exam')
          }).catch(() => {
            this.saveLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.$router.push('/exam')
    }
  }
}
</script>
<style scoped>
</style> 


// WEBPACK FOOTER //
// src/views/exam/ExamEdit.vue